module.exports = __webpack_public_path__ + "static/media/3DPPA2.e52e81f3.jpg";